import React from 'react';
import DropzoneBase, {
  IDropzoneProps as IBaseDropzoneProps
} from 'components/core/Dropzone/Dropzone';
import { ThemeFamilies } from 'models';

interface IDropzoneProps extends IBaseDropzoneProps {}

const Dropzone = ({
  className,
  name = '',
  text = '',
  themeFamily = ThemeFamilies.PRIMARY,
  dropzoneOptions,
  ...rest
}: IDropzoneProps) => {
  return (
    <DropzoneBase
      className={className}
      name={name}
      text={text}
      themeFamily={themeFamily}
      dropzoneOptions={dropzoneOptions}
      {...rest}
    />
  );
};

export default Dropzone;
